import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";
import { DashboardLayout } from "@/components/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import AgendaPage from "@/pages/AgendaPage";
import PatientsPage from "@/pages/PatientsPage";
import PatientDetailPage from "@/pages/PatientDetailPage";
import EpisodeDetailPage from "@/pages/EpisodeDetailPage";
import ExercisesPage from "@/pages/ExercisesPage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import PaymentsPage from "@/pages/PaymentsPage";
import SettingsPage from "@/pages/SettingsPage";
import PatientPortalPage from "@/pages/PatientPortalPage";
// PWA del usuario final (Fase 4b)
import { AppProviderLayout, AppProtectedLayout } from "@/pages/app/AppShell";
import AppLoginPage from "@/pages/app/AppLoginPage";
import AppClaimPage from "@/pages/app/AppClaimPage";
import AppHomePage from "@/pages/app/AppHomePage";
import AppLogSessionPage from "@/pages/app/AppLogSessionPage";
import AppHistoryPage from "@/pages/app/AppHistoryPage";
import AppProfilePage from "@/pages/app/AppProfilePage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-3 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-muted-foreground">Cargando...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/portal" element={<PatientPortalPage />} />

      {/* PWA del usuario final (Fase 4b) — identidad y provider propios (enduser_token) */}
      <Route path="/app" element={<AppProviderLayout />}>
        <Route path="login" element={<AppLoginPage />} />
        <Route path="claim" element={<AppClaimPage />} />
        <Route element={<AppProtectedLayout />}>
          <Route index element={<AppHomePage />} />
          <Route path="registrar/:planId" element={<AppLogSessionPage />} />
          <Route path="historial" element={<AppHistoryPage />} />
          <Route path="perfil" element={<AppProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Route>

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="pacientes" element={<PatientsPage />} />
        <Route path="pacientes/:id" element={<PatientDetailPage />} />
        <Route path="ejercicios" element={<ExercisesPage />} />
        <Route path="programas" element={<ProgramsPage />} />
        <Route path="programas/:id" element={<ProgramDetailPage />} />
        <Route path="episodios/:id" element={<EpisodeDetailPage />} />
        <Route path="pagos" element={<PaymentsPage />} />
        <Route path="configuracion" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
